/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['#article-header{height:120px;padding-top:10px}#category-header{height:60px;padding-top:10px}.header.economy{background-color:#09f}.header.personal-finance{background-color:#9c6}.header.business{background-color:#c6c}.header.real-estate{background-color:#f90}.header.cost-guides-list{background-color:#9c6}\n'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvc2hhcmVkL2RlY29yYXRvci9zdWJoZWFkZXIvc3ViaGVhZGVyLmNvbXBvbmVudC5zY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvYnVpbGQvaG93bXVjaC9zcmMvYXBwL3NoYXJlZC9kZWNvcmF0b3Ivc3ViaGVhZGVyL3N1YmhlYWRlci5jb21wb25lbnQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/ngfactory/app/shared/decorator/subheader/subheader.component.scss.ngstyle.ts